import React, { Component } from 'react';
import PropTypes from 'prop-types';

import uuid from 'uuid/v4';
import 'icheck/skins/all.css'; // or single skin css
import { Checkbox as ICheck } from 'react-icheck';

class Checkbox extends Component {
  render() {
    const { label, checked, onChange, ...spreadProps } = this.props;

    return (
      <div>
        <ICheck
          id={this.uuid}
          checkboxClass="icheckbox_square-blue"
          checked={checked}
          onChange={(e, checked) => {
            e.target.checked = checked;
            onChange(e);
          }}
          {...spreadProps}
        />
        {this.props.label && <label htmlFor={this.uuid}>{this.props.label}</label>}
      </div>
    );
  }
}

export default Checkbox;



// WEBPACK FOOTER //
// src/modules/common/components/form/Checkbox.js